import { API, graphqlOperation } from "aws-amplify";
import {
    updateCreateOrderOfBilling,
} from "../graphql/mutations";

export async function updateZauData(billingNo, id) {
    try {
        const result = await API.graphql(
            graphqlOperation(updateCreateOrderOfBilling, {
              input: {
                id: id,
                order_payment_no: billingNo,
                dateAdminUpdate: Date.now()
              },
            })
        );
        return result;
    } catch (error) {
        console.error("Error updating ZAU data:", error);
        throw error; 
    }
}